jQuery(document).ready(function($) {
    var resizeTimer;

    $('body').on('click', 'a', function (e) {
        if ($(this).attr('href') == " " || $(this).attr('href') == "" || $(this).attr('href') == "#") {
            e.preventDefault();
        }
    });

    $( window ).resize(function() {
        window.isResizing = true;

        resizeTimer = setTimeout(function() {
            Me.dispatch.emit('resize', this);
            window.isResizing = false;
        }, 250);
    });
    // Me.dispatch.emit('WindowLoaded', this);
    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('scroll'));
});
